import _ToolBar from '../ToolBar.jsx'
import MenuButtonSaveMap from './MenuButtonSaveMap.jsx'

export default function ToolBar(props) {
    return (
        <_ToolBar {...props}>
            <div></div>

            <div>
                <MenuButtonSaveMap />
            </div>
        </_ToolBar>
    )
}
